export const Breakpoints = {
  sm: 560,
  md: 865,
  lg: 960,
  header: 1100,
  narrow: 865,
  xl: 1350,
  xxl: 1600,
};

const brPx = {};
Object.keys(Breakpoints).map((key) => {
  brPx[key] = `${Breakpoints[key]}px`;
});

export const BreakpointsWithPx = brPx;

